import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { SessionService } from "@app/shared/services/session.service";

@Component({
    selector: 'app-table-filter',
    templateUrl: './table-filter.component.html',
    styleUrls: ['./table-filter.component.scss'],
    host: {
        class: 'app-table-filter'
    },
    standalone: false
})
export class TableFilterComponent implements OnInit {

	@Input()
	filterType: FilterType = FilterType.Text;

	@Input()
	placeHolder: string = 'Filter';

	@Input()
	cssClass: string = 'p-column-filter';

	@Input()
	filterData: FilterDataType[] = [];

	@Input()
	dataTestId?: string;

	@Output()
	onFilter = new EventEmitter();

	filterTypes = FilterType;
	data: any;
	initial: any;

	constructor(
		private translate: TranslateService,
		public session: SessionService,
		public router: Router) {

	}

	ngOnInit(): void {

	}

	setDefault(){
		this.initial = this.data == null ? null : JSON.parse(JSON.stringify(this.data));
	}

  private getSingleDropdownValue(): string | null {
    if (this.data == null) {
      return null;
    }

    if (Array.isArray(this.data)) {
      return this.data.length > 0 ? this.data[0]?.toString() : null;
    }

    return this.data?.id?.toString()
      ?? this.data?.key?.toString()
      ?? this.data?.toString()
      ?? null;
  }

  private getMultiDropdownValue(): string[] | null {
    if (this.data == null) {
      return null;
    }

    if (!Array.isArray(this.data)) {
      return [];
    }

    return this.data
      .map((item: any) => {
        if (item == null) {
          return null;
        }

        if (typeof item === 'object') {
          return item.id?.toString() ?? item.key?.toString() ?? null;
        }

        return item.toString();
      })
      .filter((item: string | null): item is string => !!item);
  }

	searchNotPropagate(event: any, force: boolean = false){
		if (event.key === "Enter") {
			this.search(true);
			this.initial = this.data;
			event.stopPropagation();
		}
	}

	clear(){
		this.data = null;
		this.onFilter.emit(this.data);
	}

	search(isCalendar: boolean = false){
		if (isCalendar == false && this.initial == this.data) {
			return;
		}

		if (this.data === null) {
			this.onFilter.emit(this.data);
			return;
		}

    try {
      this.initial = this.data !== undefined ? JSON.parse(JSON.stringify(this.data)) : null;
    } catch (e) {
      console.warn('Invalid data for JSON.parse', this.data);
      this.initial = null;
    }

		switch (this.filterType) {
			case FilterType.Date :
				if (this.data) {
					this.onFilter.emit(this.data);
				}
				break;

      case FilterType.Combo:
      case FilterType.ComboAsync:
        this.onFilter.emit(this.getSingleDropdownValue());
        break;

      case FilterType.ComboCheckbox:
        this.onFilter.emit(this.getMultiDropdownValue());
        break;

			case FilterType.Numeric :
				this.onFilter.emit(this.data?.toString());
				break;

			default:
				this.onFilter.emit(this.data);
				break;
		}
	}
}

export enum FilterType {
	None,
	Text,
	Numeric,
	Date,
	DateTime,
	Time,
	Combo,
	ComboAsync,
	ComboCheckbox,
	CustomDropdown
}

export interface FilterDataType{
	key: string;
	name: string;
}
